__turbopack_context__.v({
  "blocksBackgroundColor": "StaticGrid-module-scss-module__A61Fiq__blocksBackgroundColor",
  "blocksFontColor": "StaticGrid-module-scss-module__A61Fiq__blocksFontColor",
  "noContent": "StaticGrid-module-scss-module__A61Fiq__noContent",
  "pageBody": "StaticGrid-module-scss-module__A61Fiq__pageBody",
  "secondaryNavBackgroundColor": "StaticGrid-module-scss-module__A61Fiq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "StaticGrid-module-scss-module__A61Fiq__themeBackgroundColor",
  "themeFontColor": "StaticGrid-module-scss-module__A61Fiq__themeFontColor",
  "transitionExit": "StaticGrid-module-scss-module__A61Fiq__transitionExit",
  "transitionExitActive": "StaticGrid-module-scss-module__A61Fiq__transitionExitActive",
});
